<template>
  <div v-loading="processing" class="medication-list-item">
    <div class="medication-list-item__header">
      <label class="medication-list-item__title" :for="`select-medication-${medication.id}`">
        <input
          :id="`select-medication-${medication.id}`"
          type="checkbox"
          :checked="selected"
          @input="$emit('select', medication.id)">
        <h4>{{ medication.data.medicationReference.display }}</h4>
      </label>
      <span>{{ medication.created_at | date }}</span>
    </div>
    <dl class="medication-list-item__body">
      <dd />
      <dd />
      <dd class="l-peq mb-0">
        Administrar <span v-if="dispenseQuantity > 0">{{dispenseQuantity}} ({{numeroALetras(dispenseQuantity)}}) {{dispenseQuantity > 1 ? 'unidades' : 'unidad'}}</span>
      </dd>
      <dd>
        <table class="l-peq" style="width:100%;">
          <tbody>
            <tr>
              <td>Dosis</td>
              <td>Frecuencia</td>
              <td>Vía de administración</td>
              <td>Periodo de Tratamiento</td>
            </tr>
            <tr>
              <td>
                {{ getDosis }}
              </td>
              <td>
                cada {{ getFrecuencia }}
              </td>
              <td>{{ getVia }}</td>
              <td>Por {{ getPeriod }}</td>
            </tr>
          </tbody>
        </table>
      </dd>
    </dl>
    <div class="medication-list-item__footer">
      <button
        class="btn btn-link"
        type="button"
        @click.prevent="handleClickEditButton">
        <i class="fas fa-edit mr-2" aria-hidden="true" />Editar
      </button>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get';
import numeroALetras from '@/helpers/numeroLetras';

export default {
  name: 'MedicationListItem',
  props: {
    medication: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'medication-request'
    },
    selected: {
      type: Boolean,
      default: false
    },
    processing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dispenseQuantity(){
      try {
        return parseInt(this.medication.data.dispenseRequest.quantity);
      } catch (e){
        return 0;
      }
    },
    medicationDrugForms() {
      return this.$store.getters.drugForms;
    },
    doseSummary() {
      const doseQuantity = _get(this.medication, 'data.dosageInstruction[0].doseAndRate[0].doseQuantity');
      const doseTiming = _get(this.medication, 'data.dosageInstruction[0].timing.repeat');
      const route = _get(this.medication, 'data.dosageInstruction[0].route.coding[0].display');
      return `${doseQuantity.value} ${doseQuantity.unit} / ${this.formatPlural(doseTiming.period, doseTiming.periodUnit)} / ${route}`;
    },
    getDosis() {
      const doseQuantity = _get(this.medication, 'data.dosageInstruction[0].doseAndRate[0].doseQuantity');
      return this.pluralDoseQuantity(doseQuantity.value, doseQuantity.unit);
    },
    getFrecuencia() {
      const doseTiming = _get(this.medication, 'data.dosageInstruction[0].timing.repeat');
      return this.formatPlural(doseTiming.period, doseTiming.periodUnit, true);
    },
    getVia() {
      const route = _get(this.medication, 'data.dosageInstruction[0].route.coding[0].display');
      return route;
    },
    getPeriod() {
      const period = _get(this.medication, 'data.dosageInstruction[0].timing.repeat.boundsDuration');
      return this.formatPlural(period.value, period.code);
    }
  },
  methods: {
    numeroALetras : numeroALetras,
    pluralDoseQuantity(doseQuantity, doseValue) {
      let pluralValue = doseValue;
      if (doseQuantity > 1) {
        switch (doseValue) {
          case 'anillo vaginal': pluralValue = 'anillos vaginales'; break;
          case 'cápsula vaginal': pluralValue = 'cápsulas vaginales'; break;
          case 'jeringa prellenada': pluralValue = 'jeringas prellenadas'; break;
          case 'aplicación': pluralValue = 'aplicaciones'; break;
          case 'bidón': pluralValue = 'bidones'; break;
          case 'dosis': pluralValue = 'dosis'; break;
          case 'gotas': pluralValue = 'gotas'; break;
          case 'matraz': pluralValue = 'matraces'; break;
          case 'unidades internacionales': pluralValue = 'unidades internacionales'; break;
          case 'unidades': pluralValue = 'unidades'; break;
          case 'vial': pluralValue = 'viales'; break;
          default: pluralValue = `${doseValue}s`;
        }
      }

      return `${doseQuantity} ${pluralValue}`;
    },
    getUnitOfTimeDisplay(periodUnit) {
      return this.$store.getters.unitsOfTime.find(u => u.code === periodUnit).display;
    },
    handleClickEditButton() {
      this.$emit('edit-medication', this.medication.data);
    },
    formatPlural(value, period, quitA = false) {
      let timing = value > 1 ? {
        'h': 'horas',
        'd': 'días',
        's': 'segundos',
        'min': 'minutos',
        'wk': 'semanas',
        'm': 'meses',
        'mo': 'meses',
        'a': 'años'
      } : {
        'h': 'hora',
        'd': 'día',
        's': 'segundo',
        'min': 'minuto',
        'wk': 'semana',
        'm': 'mes',
        'mo': 'mes',
        'a': 'año'
      };

      return value + ' ' + (timing[period] ? timing[period] : period);
    }
  }
};
</script>

<style lang="scss">
.medication-list-item {
  position: relative;
  padding: $--spacing-6;
  border: 1px solid #D2D9E1;
  border-radius: $--border-radius-base;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.06);
  &__title {
    display: flex;
    margin-bottom: 0;
    align-items: center;
    input[type="checkbox"] {
      margin-right: 5px;
    }
    h4 {
      margin: 0;
    }
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
